export const TILE_CLASSES = {
    headingTile: 'heading-tile',
    groupTile: 'group-tile',
    fliTile: 'fli-tile',
    subFliTile: 'sub-fli-tile',
    adjustmentTile: 'adjustment-tile',
    accountTile: 'account-tile',
    subtotalTile: 'subtotal-tile',
} as const;
